import React from 'react';

const BillingDetailFormModal = React.lazy(() => import('../components/FormModal'));
const billingDetailModalRegistry = {
    core_billingDetailId: BillingDetailFormModal
};
export default billingDetailModalRegistry;
